import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=1ec1a2ba"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"
import style0 from "./Editor.vue?vue&type=style&index=0&id=1ec1a2ba&prod&lang=scss"
import style1 from "./Editor.vue?vue&type=style&index=1&id=1ec1a2ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports